<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 v-if="store.state.editing" style="float:left;">Edit Service</h1>
                    <h1 v-else style="float:left;">Add Service</h1>
                  </div>
                </div>
                <!-- Content -->
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Service Name</label>
                      <input @input="nameChange" v-model="store.state.form.name" class="form-control" placeholder="Name"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Slug(Page Link)</label><br>
                      <input v-model="store.state.form.slug" class="form-control" placeholder="Slug"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Active</label>
                      <select class="form-control" v-model="store.state.form.active">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Account Required</label><br>
                      <small>When checked, an account is required to view the listings for this services</small>
                      <select class="form-control" v-model="store.state.form.accountRequired">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Archive After Completion</label><br>
                      <small>If enabled, the listing will be moved to the archived section after the date of the event.</small>
                      <select class="form-control" v-model="store.state.form.archiveAfterCompletion">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6" v-if="store.state.form.archiveAfterCompletion == 1">
                    <div class="form-group">
                      <label>Remove Archived After 6 Months</label><br>
                      <small>If enabled, the listing will be removed from the archive section after 6 months</small>
                      <select class="form-control" v-model="store.state.form.removeAfter6Months">
                        <option value="">--Select an Option--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Description</label>
                      <textarea v-model="store.state.form.description" class="form-control" placeholder="Description"/>
                    </div>
                  </div>
                  <div class="col-sm-12 text-center" style="margin-top:20px;">
                    <button v-if="!store.state.editing" @click="createService" style="width:200px;" class="btn btn-primary btn-blue">Create</button>
                    <button v-else @click="updateService" style="width:200px;" class="btn btn-primary btn-blue">Save Changes</button>
                  </div>
                </div>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminAddServiceStore from './AdminAddServiceStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminAddService',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminAddServiceStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      if(this.$route.params.serviceId){
        this.store.state.serviceId = this.$route.params.serviceId
        this.store.state.editing = true
        this.fetchService();
      }
    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    })
  },
  methods: {
    createService: function () {
      this.store.createService((data)=>{
        this.$toasted.show('Service Created!',{type :'success',duration:2500});
        this.store.state.form.name = ''
      },(err)=>{
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    fetchService: function() {
      this.store.fetchService((data)=>{
        this.$forceUpdate();
      },(err)=>{
      this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    updateService: function() {
      this.store.updateService((data)=>{
        this.$forceUpdate();
        this.$toasted.show('Changes Saved!',{type :'success',duration:2500});
      },(err)=>{
      this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    },
    nameChange() {
      this.store.state.form.slug = this.store.state.form.name.replace(" ","-").toLowerCase();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminAddService.vue